<template>
  <div class="team">
    <h1 class="h1_title">
      <img src="../../../assets/images/company/nav_team.png">团队管理
    </h1>
    <div class="move-up"></div>
    <div class="table-btn">
      <div class="btn" @click="createTeamShow=true">创建团队</div>
    </div>

    <el-table
      :data="teamList"
      v-loading="teamLoading"
      tooltip-effect="dark"
      style="width: 100%"
      height="calc(100vh - 236px)"
      class="table">
    
      <el-table-column prop="organization_name" label="团队名" min-width="180" show-overflow-tooltip=""></el-table-column>

      <el-table-column label="团队成员" min-width="176" show-overflow-tooltip>
        <template slot-scope="scope">
          <div class="member-row flex--cen" v-if="scope.row.total_number">
            <img :src="item || require('../../../assets/images/head.png')" v-for="(item,i) in scope.row.member_list" :key="i">
            <span v-if="scope.row.total_number>5">...</span>
            <span style="margin-left:10px">{{scope.row.total_number}}人</span>
          </div>
          <div v-else>暂无成员</div>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="140">
        <template slot-scope="scope">
          <span>{{$formatTime(scope.row.create_time,'y-m-d h:m')}}</span>
        </template>
      </el-table-column>
      
      <el-table-column label="操作" min-width="360" align="center">
        <template slot-scope="scope">
          <span class="btn" @click="getMember(20,1,scope)">成员列表</span>

          <span class="btn" @click="editTeam(scope.row)">修改名称</span>

          <span class="btn" @click="createReport(scope.row)" v-if="scope.row.total_number>2">生成报告</span>
          <el-tooltip v-else class="gray" content="至少3位成员才能生成报告" placement="top" :open-delay="400">
            <el-button>生成报告</el-button>
          </el-tooltip>

          <span class="btn red" v-if="scope.row.pid!=0" @click="delConfirm(scope.row,'delTeamShow')">解散团队</span>
          <el-tooltip v-else class="gray" content="该团队无法解散" placement="top" :open-delay="400">
            <el-button>解散团队</el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination ref="teamPage" @change="getTeam" :total="teamTotal"></pagination>

    <!-- 创建团队弹窗 -->
    <el-dialog
      title="创建团队"
      :visible.sync="createTeamShow"
      :close-on-click-modal="false"
      @close="closeDialog"
      width="560px"
      center>
      <div class="dialog-input-body">
        <div class="input-row">
          <h4 class="must">团队名</h4>
          <div class="box" :class="{error:errorType==1}">
            <input 
              class="input"
              placeholder='请输入新的团队名' 
              maxlength="24"
              v-model="teamName"
              @input="checkName"
              ref="teamName">
            <div class="input-icon icon-clear" title="清空" v-show="teamName" @click="teamName=''"></div>
            <div class="errText" v-show="errorType==1">{{errorMsg}}</div>
          </div>
        </div>
        <div class="input-row">
          <h4>添加成员</h4>
          <div class="box">
            <div class="member-row flex--cen" style="flex:1;margin-left:10px">
              <img :src="item.avatar || require('../../../assets/images/head.png')" v-for="(item,i) in appendList" :key="i" v-show="i<8">
              <span v-if="appendList.length>8">...</span>
              <span style="margin-left:10px" v-show="appendList.length">{{appendList.length}}人</span>
            </div>
            <button class="btnRect" @click="getChooseMember()">+</button>
          </div>
        </div>
        <p class="tips" style="text-align:left">说明：团队认知差异分析仅限于管理人员，不可添加层级为一线员工的成员</p>
        <div class="bottom-btn" @click="createTeam">创 建</div>
      </div>
    </el-dialog>
    <!-- 成员列表弹窗 -->
    <el-dialog
      title="成员列表"
      class="dialog-large"
      @close="closeDialog"
      :visible.sync="memberListShow"
      :close-on-click-modal="false"
      center>
      <div class="table-btn">
        <div class="text" v-if="teamNow"><b>{{teamNow.organization_name}}</b> &nbsp;共{{memberTotal}}人</div>
        <div class="btn" @click="getChooseMember()" v-if="addBtnShow">添加已有成员</div>
        <el-tooltip v-else class="btn btn-disable" content="已添加所有成员" placement="top" :open-delay="400">
            <el-button>添加已有成员</el-button>
        </el-tooltip>
        <!-- <div class="btn" @click="inviteShow=true">邀请新成员</div> -->
      </div>
      <el-table
        v-loading="memberLoading"
        :data="memberList"
        tooltip-effect="dark"
        :height="tableHeight"
        style="width:100%">
        <el-table-column label="姓名" min-width="110" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="table-head">
              <img :src="scope.row.avatar || require('../../../assets/images/head.png')">
              <span>{{scope.row.realname}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="性别" min-width="50" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.sex==2">女</span>
            <span v-else>男</span>
          </template>
        </el-table-column>

        <el-table-column label="手机号" min-width="110" align="center">
          <template slot-scope="scope">
            <span>{{$mobileToStar(scope.row.mobile)}}</span>
          </template>
        </el-table-column>
        
        <el-table-column label="最新激活时间" min-width="130" align="center">
          <template slot-scope="scope">
            <span>{{$formatTime(scope.row.create_time,'y-m-d h:m')}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="tier_name" label="职位层级" min-width="90" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.tier_name">{{scope.row.tier_name}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column label="自评状态" min-width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.exam_status==2" class="blue">已完成</span>
            <span v-else class="red">未完成</span>
          </template>
        </el-table-column>

        <el-table-column label="最新完成时间" min-width="132" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.end_time">{{$formatTime(scope.row.end_time,'y-m-d h:m')}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column prop="other_exam_count" label="最新他评人数" min-width="110" align="center"></el-table-column>

        <el-table-column prop="other_exam_complete_count" label="最新他评完成人数" min-width="140" align="center"></el-table-column>

        <el-table-column label="操作" min-width="190" align="center" v-if="memberList.length">
          <template slot-scope="scope">
            <span class="btn red" @click="delConfirm(scope.row,'delMemberShow')">移除成员</span>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="memberList.length>2" ref="memberPage" @change="getMember" :total="memberTotal" :position="'page-botttom'"></pagination>
    </el-dialog>
    <!-- 添加可选成员列表弹窗 -->
    <el-dialog
      title="添加成员"
      class="dialog-large"
      :visible.sync="addMemberShow"
      :close-on-click-modal="false"
      center>
      <div class="table-btn">
        <div class="btn" @click="addMember">确定</div>
      </div>

      <el-table
        v-loading="addMemberLoading"
        :data="addMemberList"
        :height="tableHeight"
        tooltip-effect="dark"
        ref="addTable"
        style="width:100%">

        <el-table-column type="selection" width="50"></el-table-column>

        <el-table-column label="姓名" min-width="110" show-overflow-tooltip>
          <template slot-scope="scope">
            <div class="table-head">
              <img :src="scope.row.avatar || require('../../../assets/images/head.png')">
              <span>{{scope.row.realname}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="性别" min-width="50" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.sex==2">女</span>
            <span v-else>男</span>
          </template>
        </el-table-column>

        <el-table-column label="手机号" min-width="110" align="center">
          <template slot-scope="scope">
            <span>{{$mobileToStar(scope.row.mobile)}}</span>
          </template>
        </el-table-column>
        
        <el-table-column label="加入时间" min-width="130" align="center">
          <template slot-scope="scope">
            <span>{{$formatTime(scope.row.create_time,'y-m-d h:m')}}</span>
          </template>
        </el-table-column>

        <el-table-column label="职位类型" min-width="90" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.type_name">{{scope.row.type_name}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column label="层级" min-width="90" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.tier_name">{{scope.row.tier_name}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column label="评估状态" min-width="100" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.exam_status==2" class="blue">已完成</span>
            <span v-else class="red">未完成</span>
          </template>
        </el-table-column>

        <el-table-column label="最新评估时间" min-width="132" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.end_time">{{$formatTime(scope.row.end_time,'y-m-d h:m')}}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      
      <pagination 
        v-show="addMemberList.length>2" 
        ref="addMemberPage"  
        :position="'page-botttom'"
        @change="getChooseMember" 
        :total="addMembeListTotal">
      </pagination>
    </el-dialog>
    <!-- 邀请新成员弹窗 -->
    <el-dialog
      title="邀请成员"
      :visible.sync="inviteShow"
      :close-on-click-modal="false"
      width="560px"
      center>
      <div class="dialog-input-body" style="height:302px">
        <div class="top-nav">
          <span :class="{current:inviteType==0}" @click="toggle(0)">手机号邀请</span>
          <span :class="{current:inviteType==1}" @click="toggle(1)">小程序码邀请</span>
        </div>

        <template v-if="inviteType==0">
          <div class="input-row">
            <h4>姓名</h4>
            <div class="box" :class="{error:errorType==3}">
              <input 
                class="input"
                placeholder='请输入真实姓名' 
                maxlength="16"
                v-model="inviteName"
                @input="setError"
                ref="inviteName">
              <div class="input-icon icon-clear" title="清空" v-show="inviteName" @click="inviteName=''"></div>
              <div class="errText" v-show="errorType==3">{{errorMsg}}</div>
            </div>
          </div>
          <div class="input-row">
            <h4>手机号</h4>
            <div class="box" :class="{error:errorType==4}">
              <el-select v-model="country_code" @change="selectCountry" class="el-select-code">
                <el-option
                  v-for="(item,code) in $country"
                  :key="code"
                  :label="item.label"
                  :value="code">
                </el-option>
              </el-select>
              <input 
                class="input"
                style="padding-top:2px"
                placeholder='请输入手机号'
                maxlength="11"
                v-model="phone"
                @input="inputChange($event,'phone')"
                ref="phone">
              <div class="input-icon icon-clear" title="清空" v-show="phone" @click="phone=''"></div>
              <div class="errText" v-show="errorType==4">{{errorMsg}}</div>
            </div>
          </div>
          <p class="tips">提示：邀请有效期为72小时</p>
          <div class="bottom-btn" @click="mobileInvite">确 认</div>
        </template>
        <template v-else-if="inviteType==1">
          <div class="input-row" style="margin:60px 0">
            <h4>数量</h4>
            <div class="box" :class="{error:errorType==5}">
              <input 
                class="input"
                placeholder='请输入数量' 
                maxlength="6"
                @input="inputChange($event,'sendNumber')"
                v-model="sendNumber">
              <div class="input-icon icon-clear" title="清空" v-show="sendNumber" @click="sendNumber=''"></div>
              <div class="errText" v-show="errorType==5">{{errorMsg}}</div>
            </div>
          </div>
          <p class="tips">提示：邀请有效期为72小时</p>
          <div class="bottom-btn loading-dot" v-if="creating">生成中<i>.</i><i>.</i><i>.</i></div>
          <div class="bottom-btn" @click="createQrcode" v-else>生成小程序码</div>
        </template>
        <template v-else>
          <div class="qrcode">
            <img :src="qrcode">
            <div class="downloadBtn" style="opacity:.8;cursor:not-allowed;" v-if="qrcodeDownload">已下载</div>
            <div @click="download" class="downloadBtn" v-else>下 载</div>
            <p>提示：被邀请人可通过扫描此小程序码进入评估，可在<router-link to="/cognition/invite">邀请管理</router-link>中查看邀请详情或结束此邀请</p>
          </div>
        </template>
      </div>
    </el-dialog>
    <!-- 生成报告弹窗 -->
    <el-dialog
      title="生成报告"
      :visible.sync="createReportShow"
      :close-on-click-modal="false" 
      @close="closeDialog"
      width="560px"
      center>
      <div class="dialog-input-body">
        <div class="input-row">
          <h4>团队名</h4>
          <div class="box gray">{{teamNow.organization_name}}</div>
        </div>
        <!-- <div class="input-row" style="margin:36px 0">
          <h4>团队人数</h4>
          <div class="box gray">{{memberTotal}}人</div>
        </div> -->
        <!-- <div class="input-row" style="margin:36px 0">
          <h4>可分析人数</h4>
          <div class="box gray abs">{{createTotal}}人
            <p>提示：团队报告只包含完成个人认知差异分析的团队成员</p>
          </div>
        </div> -->
        
        <div class="input-row">
          <h4>分析类型</h4>
          <div class="box gray">团队认知差异分析</div>
        </div>
        <div class="input-row" style="margin-bottom:0">
          <h4>可分析人数</h4>
          <div class="box gray" v-if="analyze_list.length==1">{{analyze_list[0].option}}</div>
          <div class="box" v-else>
            <el-select v-model="is_current_member" class="select-init" @change="createReport('')">
              <el-option
                v-for="item in analyze_list"
                :key="item.is_current_member"
                :label="item.option"
                :value="item.is_current_member">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="reportNumber" :style="{height:is_current_member==0?'34px':'0'}">失真数据：成员完成评估时间距今已超过90天，生成的团队报告数据不具备参考价值。</div>
        <div class="bottom-btn" @click="toReport()">确 认</div>
      </div>
    </el-dialog>
    <!-- 修改团队信息弹窗 -->
    <el-dialog
      title="修改团队名称"
      :visible.sync="changeTeamShow"
      :close-on-click-modal="false"
      @close="closeDialog"
      width="560px"
      center>
      <div class="dialog-input-body">
        <div class="input-row" style="margin:60px 0">
          <h4 class="must">团队名</h4>
          <div class="box" :class="{error:errorType==1}">
            <input 
              class="input"
              maxlength="24"
              v-model="newTeamName"
              @input="checkName"
              ref="name">
            <div class="input-icon icon-clear" title="清空" v-show="newTeamName" @click="newTeamName=''"></div>
            <div class="errText" v-show="errorType==1">{{errorMsg}}</div>
          </div>
        </div>
        <div style="margin-top:70px" class="bottom-btn" @click="updateTeam">确 认</div>
      </div>
    </el-dialog>
    <!-- 移除团队确认弹窗 -->
    <el-dialog
      title="解散团队"
      class="el-dialog-confirm"
      :visible.sync="delTeamShow"
      :close-on-click-modal="false"
      center>
      <span>确认解散[<b>{{delRow.organization_name}}</b>]？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="removeTeam">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 移除成员确认弹窗 -->
    <el-dialog
      title="移除成员"
      class="el-dialog-confirm"
      :visible.sync="delMemberShow"
      :close-on-click-modal="false"
      center>
      <span>确认移除成员[<b>{{delRow.realname}}</b>]</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="removeName">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import pagination from '../../../assets/part/page'
export default {
  components: {pagination,},
  data(){
    return {
      tableHeight: '85%',
      teamLoading: false,
      memberLoading: false,
      reg: this.$CNReg,         // 当前区号的手机号正则
      country_code: '86',       // 区号
      
      phone: '',                // 手机号码
      errorMsg: '',             // 输入框错误信息
      errorType: 0,             // 1：无团队名，2：未选架构，3：无姓名，4：手机号有误，5：邀请数量有误，6：层级有误，7：架构名为空

      memberListShow: false,    //成员列表显隐

      createTeamShow: false,    // 创建团队弹窗显隐
      createReportShow: false,  // 生成报告弹窗显隐
      changeTeamShow: false,    // 修改信息显隐

      delTeamShow: false,       // 删除确认框显隐
      delMemberShow: false,     // 删除成员框显隐
      delRow: [],               // 准备删除的列表

      addMemberShow: false,
      addBtnShow: false,
      inviteShow: false,
      inviteName: '',
      inviteType: 0,
      sendNumber: '',             // 发出邀请数
      creating: false,
      qrcode: '',
      qrcodeDownload: false,      // 是否已经下载了小程序码

      addMemberList: [],
      addMembeListTotal: 0,
      addMemberLoading: false,  

      teamTotal: 0,               // 成员总数
      teamList: [],               // 团队列表
      teamName: '',               // 姓名
      appendList: [],             // 团队添加的成员列表
      teamNow: {},                // 当前点击的团队

      memberTotal: 0,             // 某团队的成员总数
      memberList: [],             // 某团队的成员列表

      analyze_list: [],
      is_current_member: 1,

      step: 1,
      keyword: '',
      newTeamName: '',
      cStructure: '',
    }
  },
  mounted(){
    // window.onresize = () => {
    //   this.timer && clearTimeout(this.timer)
      setTimeout(()=>{
        let h = document.body.clientHeight
        if (h > 840) {
          this.tableHeight = '88.8%'
        } else if (h < 840 && h > 800) {
          this.tableHeight = '87.8%'
        } else if (h < 800 && h > 680) {
          this.tableHeight = '85.7%'
        } else {
          this.tableHeight = '82.8%'
        }
      },300)
    // }

    this.getTeam()
  },
  methods: {
    setError(type = 0, msg = ''){
      this.errorType = type
      this.errorMsg = msg
    },
    // 获取团队列表
    getTeam(per_page, page){
      let ref = this.$refs.teamPage;
      per_page = per_page ? per_page : ref ? ref.per_page : 20;
      page = page ? page : ref ? ref.page : 1;
      this.teamLoading = true
      this.$request({
        url: '/CognitiveDifferences/getTeamList',
        data: {
          // keyword: this.keyword,
          per_page: per_page,
          page: page,
        },
        success: data => {
          if (data.code == 0) {
            this.teamList = data.data.data
            this.teamTotal = data.data.total
          } else if (data.code == 101) {
            this.$router.replace({path:'/login',query:{back:this.$route.path}})
            localStorage.clear();
          } else {
            this.$message({duration:2000,message:data.msg,type:'error'})
          }
        },
        complete: () => this.teamLoading = false
      })
    },
    // 获取团队可选成员
    getChooseMember(per_page,page){
      this.addMemberShow = true
      this.addMemberLoading = true;
      
      let ref = this.$refs.addMemberPage;
      per_page = per_page ? per_page : ref ? ref.per_page : 20;
      page = page ? page : ref ? ref.page : 1;
      this.$request({
        url:'/CognitiveDifferences/getChooseMembers',
        data:{
          // keyword: this.keyword,
          per_page: per_page,
          page: page,
          team_id: (this.teamNow&&this.teamNow.id) || [],
        },
        success: (data) => {
          if (data.code == 0) {
            this.addMembeListTotal = data.data.total

            let addData = data.data.data
            this.addMemberList = data.data.data
            if(this.appendList.length){
              this.$nextTick( ()=>{
                for(let i in this.appendList){
                  for(let j in this.addMemberList){
                    if(this.appendList[i].user_id == this.addMemberList[j].user_id)
                      this.$refs.addTable.toggleRowSelection(this.addMemberList[j],true);
                  }
                }
              })
            }
          }else{
            this.$message({message: data.msg})
          }
        },
        complete: () => this.addMemberLoading = false
      })
    },
    // 获取团队里的成员列表
    getMember(per_page, page, {row}){
      this.memberLoading = true;
      this.memberListShow = true;
      this.teamNow = row ? row : this.teamNow
      let ref = this.$refs.memberPage
      per_page = per_page ? per_page : ref ? ref.per_page : 20;
      page = page ? page : ref ? ref.page : 1;
      this.$request({
        url: '/CognitiveDifferences/getMemberList',
        data: {
          per_page: per_page,
          page: page,
          team_id: this.teamNow.id,
        },
        success: data => {
          if (data.code == 0) {
            let member = data.data.member_list
            this.memberList = member.data
            this.memberTotal = member.total
            this.addBtnShow = data.data.chooseable_count
          } else {
            this.$message({duration: 2000, message: data.msg})
          }
        },
        complete: () => this.memberLoading = false
      })
    },
    addMember(){
      let selection = this.$refs.addTable.selection
      if (this.createTeamShow) {
        this.appendList = selection
        this.addMemberShow = false
      } else if (!selection.length) {
        this.$message({duration: 1000,message: '请先选择'})
      } else if (!this.addMemberList.length) {
        return
      } else {
        let memberInfo = [];
        selection.forEach(item => memberInfo.push([item.user_id, item.exam_id]) )
        this.$request({
          method: 'post',
          url: '/CognitiveDifferences/appendMember',
          data: {
            team_id: this.teamNow.id,
            member_info: memberInfo,
          },
          success: data => {
            if (data.code == 0) {
            this.$message({duration: 1000,message: '添加成功', type:'success'})
            this.addMemberShow = false
            this.getTeam()
            this.getMember('','',{})
            } else {
              this.$message({duration: 2000, message: data.msg})
            }
          },
        })
      }
    },
    createTeam(){
      if(!this.teamName){
        this.setError(1,'请先输入团队名')
        return
      }
      let member_info = []
      this.appendList.forEach( item => member_info.push([item.user_id, item.exam_id]) )
      this.$request({
        method: 'post',
        url: '/CognitiveDifferences/createTeam',
        data: {
          team_name: this.teamName,
          member_info: member_info
        },
        success: data => {
          if (!data.code) {
            this.$message({duration: 1000,message: '创建成功', type:'success'})
            this.getTeam()
            this.createTeamShow = false
          } else {
            this.$message({duration: 2000,message: data.msg})
          }
        },
      })
    },
    // 删除操作确认
    delConfirm(row,key){ 
      this[key] = true
      this.delRow = row
    },
    // 移除团队
    removeTeam(){
      this.$request({
        url: '/CognitiveDifferences/disbandTeam',
        data: {team_id: this.delRow.id},
        success: data => {
          if (!data.code) {
            this.$message({duration: 1000,message: '删除成功', type:'success'})
            this.delTeamShow = false
            this.getTeam()
          } else {
            this.$message({duration: 1500,message: data.msg})
          }
        },
      })
    },
    // 删除成员
    removeName(){
      this.$request({
        url: '/CognitiveDifferences/deleteMember',
        data: {
          team_id: this.teamNow.id,
          member_id: this.delRow.id,
        },
        success: data => {
          if (!data.code) {
            this.$message({duration: 2000,message: '移除成功', type:'success'})
            this.delMemberShow = false
            this.getTeam()
            for(let j in this.memberList){
              if(this.delRow.user_id == this.memberList[j].user_id){
                this.memberList.splice(j,1);
                break;
              }
            }
          } else {
            this.$message({duration: 1500,message: data.msg})
          }
        },
      })
    },
    // 切换 短信登录/账号密码登录
    toggle(type){
      if (this.inviteType == type)  return;
      this.inviteType = type
      this.setError()
      this.inviteName = ''
      this.phone = ''
    },
    //选择区号和手机号正则
    selectCountry(val){
      this.reg = this.$country[val].reg
      this.country_code = val
    },
    // 监听输入数字输入内容
    inputChange(e, key = 'phone'){
      let text = e.target.value
      this[key] = text.replace(/\D/g,'')
      if(key == 'sendNumber' && text.charAt(0) == '0')  this.sendNumber = text.substring(1, text.length);
      this.setError()
    },
    //手机号邀请新成员
    mobileInvite(){
      if (!this.inviteName) {
        this.setError(3,'请先输入姓名')
        this.$refs.inviteName.focus()
        return
      } else if (!this.phone) {
        this.setError(4,'请先输入手机号')
        this.$refs.phone.focus()
        return
      } else if (!this.reg.test(this.phone)) {
        this.setError(4,'手机号码格式不对')
        this.$refs.phone.focus()
        return
      }
      this.$request({
        url: '/CognitiveDifferences/baseMobileInvite',
        data: {
          realname: this.inviteName,
          mobile: this.phone,
          country_code: this.country_code,
        },
        success: data => {
          if (data.code == 0) {
            this.$message({duration: 1000,message: '邀请成功', type:'success'})
            this.inviteShow = false
            this.getMember('','',{})
          } else {
            this.$message({duration:2000, message:data.msg, type:'error'})
          }
        },
      })
    },
    // 生成邀请二维码
    createQrcode(){
      if (!this.sendNumber) {
        this.setError(5, '请输入邀请数')
        return
      }
      this.creating = true
      this.$request({
        url:'/CognitiveDifferences/codeOrgInvite',
        data: {invite_num: this.sendNumber},
        success: (data) => {
          if (data.code == 0) {
            this.$request({
              url: this.$planetUrl+'/Common/createQrcode',
              data: {
                param: data.data.id + '=' + data.data.code,
                page: 'pages/CD/accept/accept',
                width: 280,
              },
              success: (e) => {
                if (e.code == 0) {
                  this.inviteType = 2
                  this.qrcode = e.data.qrcode_path
                } else {
                  this.$message({duration: 2000, message: e.msg})
                }
              },
              complete: ()=>{
                this.creating = false
              }
            })
          } else {
            this.creating = false
            this.$message({duration: 2000, message: data.msg})
          }
        },
        error: ()=>{
          this.creating = false
          this.$message.error('网络错误，请稍后再试')
        }
      })
    },
    download(){
      if (this.qrcodeDownload == false) {
        window.open(`${this.$baseRoot}/CompanyInvite/downQrcode?qrcode_path=${this.qrcode}`)
        this.qrcodeDownload = true
      }
    },
    createReport(row){
      this.teamNow = this.teamNow.id ? this.teamNow : row
      // 获取团队可分析数据
      this.$request({
        method: 'post',
        url: '/CognitiveDifferences/getTeamAnalysisData',
        data: {
          team_id: this.teamNow.id,
          is_current_member: this.is_current_member,
        },
        success: data => {
          if (data.code == 0) {
            let list = []
            data.data.analyze_list.forEach(e => {
              if (e.is_show) list.push(e)
            })
            this.analyze_list = list
            this.memberTotal = data.data.total_number
            this.createReportShow = true
          } else {
            this.$message({duration:2000, message:data.msg, type:'error'})
          }
        },
      })
    },
    toReport(){
      this.$request({
        url: '/CognitiveDifferences/createTeamReport',
        data: {
          team_id: this.teamNow.id,
          is_current_member: this.is_current_member,
        },
        success: data => {
          if (data.code == 0) {
            // this.$router.push({path:'/cognition/report'})
            this.createReportShow = false
            window.open(`${this.$reportUrl}/cognition/#/team/${data.data.report_id}`,'_blank')
          } else {
            this.$message({message: data.msg, type: 'error'})
          }
        },
        error: () => this.$message({message: '网络错误', type: 'error'})
      })
    },
    //修改团队信息
    editTeam(row){
      this.newTeamName = row.organization_name
      this.changeTeamShow = true
      this.teamNow = row
    },
    checkName(e){
      if (e.target.selectionEnd > 31) {
        this.setError(1,'团队名过长')
      } else {
        this.setError()
      }
    },
    updateTeam(){
      if (this.errorType) {
        return
      } else if (!this.newTeamName) {
        this.setError(1,'请先输入团队名')
        return
      }
      this.$request({
        method: 'post',
        url: '/CognitiveDifferences/updateTeam',
        data: {
          team_id: this.teamNow.id,
          team_name: this.newTeamName,
        },
        success: data => {
          if (!data.code) {
            this.$message({duration: 1000,message: '修改成功', type:'success'})
            this.changeTeamShow = false
            this.getTeam()
          } else {
            this.$message({duration:1500, message:data.msg, type:'error'})
          }
        },
      })
    },
    closeDialog(){
      this.setError()
      this.phone = ''
      this.name = ''
      this.addMemberList = []
      this.newTeamName = '',
      this.teamName = ''
      this.teamNow = {}
      this.delRow = {}
      this.appendList = []
      this.qrcodeDownload = false
      this.inviteType = 0
      this.is_current_member = 1
    },
  },
}
</script>

<style lang="scss">
.team{
  transition-duration: 0s;
  *{transition-duration: 0s;}
  .member-row{
    padding-left: 6px;
    img{
      overflow: hidden;
      width: 26px;
      height: 26px;
      flex-shrink: 0;
      border-radius: 50%;
      border: 1px solid #fff;
      margin-left: -6px;
      box-shadow:  0 0 2px rgba(50,50,50,.2);
    }
  }
  .el-dialog{
    margin-top: 10vh !important;
    user-select: none;
    .reportNumber{
      margin-left: 95px;
      font-size: 12px;
      color: #ff4747;
      height: 0;
      transition: height .2s;
      overflow: hidden;
      text-align: justify;
    }
    .abs{
      position: relative;
      p{
        position: absolute;
        width: 100%;
        left: 0;
        top: 38px;
        text-align: center;
        font-size: 12px;
        color: #868686;
      }
    }
  }
  .head{
    display: flex;
    align-items: center;
    margin: 0 auto;
    span{
      text-align: left;
      overflow: hidden;
      margin: 0 2px;
      text-overflow: ellipsis;}
  }
  .qrcode{
    img{
      width: 136px;
      height: 136px;
      display: block;
      margin: -10px auto 0;
    }
    .downloadBtn{
      border-radius: 4px;
      width: 100px;
      color: #fff;
      background: #6b6be5;
      text-align: center;
      line-height: 30px;
      height: 30px;
      margin: 20px auto;
      cursor: pointer;
    }
    p{
      color: #868686;
      a{color: #6b6be5;cursor: pointer;}
    }
  }
}

@media (max-width: 1100px) {
  .team .table .head span{width: 60px}
}
</style>